import { trpc } from "lib/trpc";

export const useFriends = ({ search }: { search?: string } = {}) => {
    const trimmed = search?.trim() ?? "";
    const query = trpc.users.getAllUser.useQuery(trimmed ? { search: trimmed } : undefined, {
        placeholderData: (prev) => prev,
    });

    const { data, isInitialLoading } = query;

    const filteredUsers = data?.filter((u) => u.isSocialEnabled === true) ?? [];

    const nothingFound = !isInitialLoading && filteredUsers.length === 0;

    return {
        ...query,
        data: filteredUsers,
        nothingFound,
    };
};
